var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teacher-layout",style:({ 
	height: _vm.isHideRoute() ? '100vh' : '100%',
	width: '100%',
	position: 'relative',
	overflow: 'visible'  /* 改这里！从 hidden → visible */
})},[(_vm.isMobile)?_c('div',{staticClass:"menu-btn",staticStyle:{"z-index":"2888"},on:{"click":_vm.openMenu}},[_c('img',{staticStyle:{"width":"28px"},attrs:{"src":require("@/ico/stutas/menu.svg"),"alt":""}})]):_vm._e(),(_vm.isMobile && !_vm.isHideRoute())?_c('div',{staticClass:"mobile-menu",class:{ open: _vm.menuOpen },staticStyle:{"z-index":"2889"}},[_c('TeacherMenu',{on:{"click":_vm.closeMenu}})],1):_vm._e(),(!_vm.isMobile)?_c('el-container',{style:({ 
			height: _vm.isHideRoute() ? '100vh' : 'calc(100vh - 60px)', 
			width: '100%', 
			
		})},[(!_vm.isHideRoute())?_c('el-aside',{staticStyle:{"background":"#fff","border-right":"1px solid #eee"},attrs:{"width":"220px"}},[_c('TeacherMenu')],1):_vm._e(),_c('el-container',{style:({ 
				padding: _vm.isHideRoute() ? '0' : '20px', 
				width:_vm.isHideRoute() ?'calc(100vw - 220px)':'calc(100vw - 240px)',
				background: '#f5f7fa', 
				height: '100%',
				boxSizing: 'border-box',
				overflow: _vm.visible  /* 改这里！允许子组件正常计算宽度 */
			})},[_c('router-view')],1)],1):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"mobile-content",style:({ height: _vm.isHideRoute() ? '100vh' : 'auto' })},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }